import dialog from '@/services/dialog'
import { findKeyPaths } from '@/util/list'
import DialogWarning from '@/components/DialogWarning.vue'

/**
 * 分析条件に含まれる一時ファイル(顧客グループや商品指定など)の参照を解除し、条件を初期化する
 */
export function initializeRestrictedQueryFilter(queryFilter) {
  // ファイルアップロード系の条件を初期化
  const warningList = []
  // 顧客グループは制限モードの場合、復元しない
  clearKeyAndWarn(
    queryFilter,
    'customerGroupId',
    warningList,
    '顧客グループ情報',
  )
  // 商品指定ファイルは制限モードの場合、復元しない
  clearKeyAndWarn(
    queryFilter,
    'itemGroupId',
    warningList,
    '商品指定ファイル情報',
  )

  if (warningList.length > 0) {
    const warningMessage =
      '制限モードのため、' +
      warningList.join('・') +
      'を再利用できません。' +
      '※当時の条件は再利用できませんが、表示されている分析結果は実行当時の内容をそのまま表示しています。'
    dialog.open(DialogWarning, warningMessage)
  }
}

/**
 * queryFilterの中で指定したキーを持つすべてのプロパティを初期化し、警告を記録する
 *
 * @param {Object} queryFilter - 対象オブジェクト
 * @param {string} key - 初期化したいプロパティ名
 * @param {Array<string>} warningList - 警告メッセージを格納する配列
 * @param {string} warningMessage - 警告リストに追加する文言
 */
function clearKeyAndWarn(queryFilter, key, warningList, warningMessage) {
  const paths = findKeyPaths(queryFilter, key)

  paths.forEach(path => {
    const keys = path.split('.')
    let current = queryFilter

    // 最後のキーの親オブジェクトまで辿る
    for (let i = 0; i < keys.length - 1; i++) {
      if (current == null) return
      current = current[keys[i]]
    }

    const lastKey = keys[keys.length - 1]

    // キーの値が存在していたら初期化して警告を追加
    if (current && current[lastKey]) {
      if (!warningList.includes(warningMessage)) {
        warningList.push(warningMessage)
      }

      current[lastKey] = undefined
    }
  })
}
